(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["about-us-years"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', () => {
    deferSwiper(function() {
      const timelineSwiper = new Swiper('.timeline__list', {
        slidesPerView: 1,
      });

      const timelinePaginationItems = document.querySelectorAll('.timeline__pagination-item');
      timelinePaginationItems.forEach((item, index) => {
        item.addEventListener('click', () => {
          timelineSwiper.slideTo(index);
        });
      });

      timelinePaginationItems[0].classList.add('active');

      timelineSwiper.on('slideChange', () => {
        timelinePaginationItems.forEach((item, index) => {
          if (index === timelineSwiper.activeIndex) {
            item.classList.add('active');
          } else {
            item.classList.remove('active');
          }
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 1140px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', this.header.offsetHeight + "px");
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  // Prevent body scroll when menu drawer is open - Fixed version
  document.addEventListener('DOMContentLoaded', function() {
    const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
    const body = document.body;
    let scrollPosition = 0;
    
    if (menuDrawerDetails) {
      // Function to prevent body scroll without affecting drawer positioning
      function preventBodyScroll() {
        // Store current scroll position
        scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
        
        // Add class to prevent scrolling
        body.classList.add('menu-drawer-open');
        
  //       // Set body position to prevent scroll (iOS Safari fix)
  //       body.style.top = `-${scrollPosition}px`;
  //       body.style.left = '0';
  //       body.style.right = '0';
        
        // Prevent touch scrolling on mobile
        body.style.touchAction = 'none';
      }
      
      // Function to restore body scroll
      function restoreBodyScroll() {
        // Remove class and styles
        body.classList.remove('menu-drawer-open');
        body.style.overflow = '';
        body.style.paddingRight = '';
        body.style.touchAction = '';
      }
      
      // Get scrollbar width to prevent layout shift
      function getScrollbarWidth() {
        const outer = document.createElement('div');
        outer.style.visibility = 'hidden';
        outer.style.overflow = 'scroll';
        outer.style.msOverflowStyle = 'scrollbar';
        document.body.appendChild(outer);
        
        const inner = document.createElement('div');
        outer.appendChild(inner);
        
        const scrollbarWidth = outer.offsetWidth - inner.offsetWidth;
        document.body.removeChild(outer);
        
        return scrollbarWidth;
      }
      
      // Monitor menu drawer state changes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            const isMenuOpen = menuDrawerDetails.hasAttribute('open');
            
            if (isMenuOpen) {
              preventBodyScroll();
            } else {
              restoreBodyScroll();
            }
          }
        });
      });
      
      // Start observing menu drawer for open attribute changes
      observer.observe(menuDrawerDetails, {
        attributes: true,
        attributeFilter: ['open']
      });
      
      // Handle ESC key to close drawer
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape' && menuDrawerDetails.hasAttribute('open')) {
          menuDrawerDetails.removeAttribute('open');
        }
      });
    }
  });

  // Mobile currency selector setup - simplified version without JS visibility control
  document.addEventListener('DOMContentLoaded', function() {
    const currencySelector = document.querySelector('.desktop-localization-wrapper localization-form');
    
    if (currencySelector) {
      // Create a mobile-specific currency selector
      const mobileCurrencyWrapper = currencySelector.cloneNode(true);
      mobileCurrencyWrapper.classList.remove('small-hide', 'medium-hide');
      mobileCurrencyWrapper.classList.add('large-up-hide', 'mobile-menu-currency-selector');
      
      // Insert before wishlist icon
      const wishlistIcon = document.querySelector('.header__icon--wishlist.large-up-hide');
      if (wishlistIcon) {
        wishlistIcon.parentNode.insertBefore(mobileCurrencyWrapper, wishlistIcon);
      }
      
      // Re-initialize the cloned form functionality
      setTimeout(() => {
        const clonedForm = mobileCurrencyWrapper.querySelector('localization-form');
        if (clonedForm && typeof window.customElements !== 'undefined') {
          clonedForm.outerHTML = clonedForm.outerHTML;
        }

        // Initialize mobile dropdown functionality
        setTimeout(() => {
          const disclosureButton = mobileCurrencyWrapper.querySelector('.disclosure__button');
          const disclosureWrapper = mobileCurrencyWrapper.querySelector('.disclosure__list-wrapper');

          if (disclosureButton && disclosureWrapper) {
            const newButton = disclosureButton.cloneNode(true);
            disclosureButton.parentNode.replaceChild(newButton, disclosureButton);
            
            newButton.addEventListener('click', function(e) {
              e.preventDefault();
              e.stopPropagation();
              
              const wrapper = mobileCurrencyWrapper.querySelector('.disclosure__list-wrapper');
              const isHidden = wrapper.hasAttribute('hidden');
              
              if (isHidden) {
                wrapper.removeAttribute('hidden');
                newButton.setAttribute('aria-expanded', 'true');
              } else {
                wrapper.setAttribute('hidden', '');
                newButton.setAttribute('aria-expanded', 'false');
              }
            });

            // Close mobile dropdown when clicking outside
            document.addEventListener('click', function(e) {
              if (!mobileCurrencyWrapper.contains(e.target)) {
                const wrapper = mobileCurrencyWrapper.querySelector('.disclosure__list-wrapper');
                if (wrapper && !wrapper.hasAttribute('hidden')) {
                  wrapper.setAttribute('hidden', '');
                  const button = mobileCurrencyWrapper.querySelector('.disclosure__button');
                  if (button) {
                    button.setAttribute('aria-expanded', 'false');
                  }
                }
              }
            });
            
            disclosureWrapper.setAttribute('hidden', '');
            newButton.setAttribute('aria-expanded', 'false');
          }
        }, 100);
      }, 100);
    }
  });

  // Ensure wishlist icons work with GW Customer Accounts system
  document.addEventListener('DOMContentLoaded', function() {
    const wishlistIcons = document.querySelectorAll('.header__icon--wishlist');
    
    // Enhanced initialization function
    function initializeWishlistFunctionality() {
      const gwCustomerAccounts = document.querySelector('gw-customer-accounts');
      
      if (gwCustomerAccounts) {
        console.log('GW Customer Accounts found, initializing wishlist...');
        
        wishlistIcons.forEach(function(icon) {
          if (!icon.classList.contains('gw-initialized')) {
            icon.classList.add('gw-initialized');
            icon.setAttribute('data-initialized', 'true');
            
            // Remove any existing event listeners by cloning the element
            const newIcon = icon.cloneNode(true);
            icon.parentNode.replaceChild(newIcon, icon);
            
            // Add the click event listener
            newIcon.addEventListener('click', function(e) {
              e.preventDefault();
              console.log('Wishlist icon clicked, navigating to #my-favorites');
              
              // Force navigation to wishlist
              window.location.hash = 'my-favorites';
              
              // Also try to trigger the GW Customer Accounts navigation
              if (gwCustomerAccounts && gwCustomerAccounts.navigateToTab) {
                try {
                  gwCustomerAccounts.navigateToTab('dashboard', 'favorites');
                } catch (error) {
                  console.log('Direct navigation failed, using hash navigation');
                }
              }
            });
          }
        });
        
        return true; // Successfully initialized
      }
      
      return false; // Not initialized
    }
    
    // Try immediate initialization
    if (!initializeWishlistFunctionality()) {
      console.log('GW Customer Accounts not ready, waiting...');
      
      // Retry initialization with multiple strategies
      let retryCount = 0;
      const maxRetries = 50; // 5 seconds max wait
      
      const retryInit = setInterval(() => {
        retryCount++;
        
        if (initializeWishlistFunctionality()) {
          clearInterval(retryInit);
          console.log('Wishlist initialized successfully after retries');
        } else if (retryCount >= maxRetries) {
          clearInterval(retryInit);
          console.warn('Failed to initialize wishlist after maximum retries');
          
          // Fallback: Add simple hash navigation
          wishlistIcons.forEach(function(icon) {
            icon.addEventListener('click', function(e) {
              e.preventDefault();
              window.location.hash = 'my-favorites';
            });
          });
        }
      }, 100);
    }
    
    // Also watch for the GW Customer Accounts component to be added dynamically
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.addedNodes.length) {
          const addedGWCA = Array.from(mutation.addedNodes).find(node => 
            node.tagName === 'GW-CUSTOMER-ACCOUNTS' || 
            (node.querySelector && node.querySelector('gw-customer-accounts'))
          );
          if (addedGWCA) {
            console.log('GW Customer Accounts added to DOM, reinitializing...');
            setTimeout(() => initializeWishlistFunctionality(), 500);
          }
        }
      });
    });
    
    observer.observe(document.body, {
      childList: true,
      subtree: true
    });
    
    // Additional event listeners for different loading scenarios
    window.addEventListener('load', function() {
      setTimeout(() => initializeWishlistFunctionality(), 1000);
    });
    
    // Listen for Shopify theme events
    document.addEventListener('shopify:section:load', function() {
      setTimeout(() => initializeWishlistFunctionality(), 500);
    });
    
    // Listen for custom GW events
    document.addEventListener('gw:ready', function() {
      console.log('GW ready event fired');
      initializeWishlistFunctionality();
    });
  });

  // Prevent sl-drawer from opening when clicking wishlist/account icons
  document.addEventListener('DOMContentLoaded', function() {
    const wishlistIcons = document.querySelectorAll('.header__icon--wishlist');
    const accountIcons = document.querySelectorAll('.header__icon--account');
    
    // Function to prevent sl-drawer opening
    function preventSlDrawer() {
      // Close any open sl-drawer immediately
      const slDrawers = document.querySelectorAll('sl-drawer');
      slDrawers.forEach(drawer => {
        if (drawer.hasAttribute('open')) {
          drawer.removeAttribute('open');
          drawer.hide();
        }
      });
    }
    
    // Add click handlers to wishlist icons
    wishlistIcons.forEach(function(icon) {
      icon.addEventListener('click', function(e) {
        // Prevent sl-drawer from opening
        preventSlDrawer();
        
        // Also prevent it after a short delay in case it opens later
        setTimeout(preventSlDrawer, 10);
        setTimeout(preventSlDrawer, 50);
        setTimeout(preventSlDrawer, 100);
      });
    });
    
    // Add click handlers to account icons  
    accountIcons.forEach(function(icon) {
      icon.addEventListener('click', function(e) {
        // Prevent sl-drawer from opening
        preventSlDrawer();
        
        // Also prevent it after a short delay in case it opens later
        setTimeout(preventSlDrawer, 10);
        setTimeout(preventSlDrawer, 50);
        setTimeout(preventSlDrawer, 100);
      });
    });
    
    // Global observer to catch any sl-drawer that tries to open
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
          const target = mutation.target;
          if (target.tagName === 'SL-DRAWER') {
            // If an sl-drawer just opened, close it immediately
            target.removeAttribute('open');
            target.hide();
          }
        }
      });
    });
    
    // Start observing for sl-drawer openings
    document.querySelectorAll('sl-drawer').forEach(drawer => {
      observer.observe(drawer, {
        attributes: true,
        attributeFilter: ['open']
      });
    });
  });

  // Menu drawer positioning script
  document.addEventListener('DOMContentLoaded', function() {
    const menuDrawerDetails = document.querySelector('#Details-menu-drawer-container');
    
    if (menuDrawerDetails) {
      // Function to handle when menu drawer is open
      function handleMenuDrawerOpen() {
        // When drawer is open - apply relative positioning
        const stickySubnav = document.querySelector(".section-sticky-subnav");
        if (stickySubnav) {
          stickySubnav.style.position = "relative";
          stickySubnav.style.top = "-2px";
        }
      }
      
      // Function to handle when menu drawer is closed  
      function handleMenuDrawerClosed() {
        // When drawer is closed - restore sticky positioning
        const stickySubnav = document.querySelector(".section-sticky-subnav");
        const headerWrapper = document.querySelector(".header-wrapper--border-bottom");
        
        if (stickySubnav) {
          stickySubnav.style.position = "sticky";
          stickySubnav.style.top = "calc(var(--header-height) - 2px)";
        }
        
        if (headerWrapper) {
          headerWrapper.style.position = "relative";
          headerWrapper.style.top = "-1px";
        }
      }
      
      // Monitor menu drawer state changes
      const observer = new MutationObserver(function(mutations) {
        mutations.forEach(function(mutation) {
          if (mutation.type === 'attributes' && mutation.attributeName === 'open') {
            const isMenuOpen = menuDrawerDetails.hasAttribute('open');
            
            if (isMenuOpen) {
              // Menu drawer is open - execute first part of code
              handleMenuDrawerOpen();
            } else {
              // Menu drawer is closed - execute second part of code
              handleMenuDrawerClosed();
            }
          }
        });
      });
      
      // Start observing menu drawer for open attribute changes
      observer.observe(menuDrawerDetails, {
        attributes: true,
        attributeFilter: ['open']
      });
      
      // Initial check - apply appropriate state on page load
      const isInitiallyOpen = menuDrawerDetails.hasAttribute('open');
      if (isInitiallyOpen) {
        handleMenuDrawerOpen();
      } else {
        handleMenuDrawerClosed();
      }
    }
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["shop-by-category"] && !Shopify.designMode) return;
  try {
    
  document.addEventListener('DOMContentLoaded', function () {
    const MAX_SLIDES_PER_VIEW_DESKTOP = 8;
    const MAX_SLIDES_PER_VIEW_TABLET = 4;
    const MAX_SLIDES_PER_VIEW_MOBILE = 2;

    const collectionList = document.querySelector('.shop-by-category__collections');
    const collectionLength = collectionList.getAttribute('data-collection-size');

    let swiperSlidesPerViewDesktop = collectionLength;
    let swiperSlidesPerViewTablet = collectionLength;
    let swiperSlidesPerViewMobile = collectionLength;

    if (collectionLength > MAX_SLIDES_PER_VIEW_DESKTOP) {
      swiperSlidesPerViewDesktop = MAX_SLIDES_PER_VIEW_DESKTOP + 0.5;
    }

    if (collectionLength > MAX_SLIDES_PER_VIEW_TABLET) {
      swiperSlidesPerViewTablet = MAX_SLIDES_PER_VIEW_TABLET + 0.5;
    }

    if (collectionLength > MAX_SLIDES_PER_VIEW_MOBILE) {
      swiperSlidesPerViewMobile = MAX_SLIDES_PER_VIEW_MOBILE + 0.5;
    }

    deferSwiper(function() {
      const swiper = new Swiper(collectionList, {
        spaceBetween: 15,
        breakpoints: {
          320: {
            slidesPerView: swiperSlidesPerViewMobile,
          },
          768: {
            slidesPerView: swiperSlidesPerViewTablet,
          },
          1024: {
            slidesPerView: swiperSlidesPerViewDesktop,
          },
        },
      });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
